import m from "mithril";
import { doublefinLogoWithText } from "./SvgImages";

export const LogoWithText: m.Component = {
  view() {
    return m("div.h-16.w-72", m(doublefinLogoWithText));
  },
};
